import Welcome from "./components/Welcome";
import Features from "./components/Features";
import Others from "./components/Others";
import GetInTouch from "../home/components/GetInTouch";
import SEO from "../../components/common/SEO";
    
const index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Youstad Docket",
    "description": "Advanced timetable creator and schedule management system for academies. Organize classes, manage schedules, and optimize time allocation.",
    "url": "https://youstad.com/docket",
    "applicationCategory": "EducationalApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": [
      "Timetable Creation",
      "Schedule Management",
      "Class Organization",
      "Time Optimization"
    ]
  };

  return (
    <>
      <SEO
        title="Youstad Docket - Timetable Creator & Schedule Management | Academy Time Organization"
        description="Advanced timetable creator and schedule management system for academies. Organize classes, manage schedules, and optimize time allocation with Youstad Docket."
        keywords="timetable creator, schedule management, class scheduling, academy timetable, time management, schedule optimization, educational scheduling"
        url="https://youstad.com/docket"
        structuredData={structuredData}
      />
      <Welcome />
      <Features />
      <Others />
      <GetInTouch />
    </>
  );
}; 

export default index;